import React from 'react';
import PropTypes from 'prop-types';
import { createMemoStyles, safeRest } from '@wds/utils';
import { useTheme } from 'react-jss';

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var useStyles = createMemoStyles(function (theme) {
  var palette = theme.palette,
      radius = theme.radius,
      shadow = theme.shadow;
  var button = {
    borderRadius: radius.small,
    boxShadow: shadow.none
  };
  return {
    wrenchButtonGroup: function wrenchButtonGroup(_ref) {
      var radio = _ref.radio;
      return {
        display: 'inline-flex',
        boxShadow: button.boxShadow,
        borderRadius: button.borderRadius,
        // supports Buttons as well as Buttons that are nested in a Menu
        '& > button, & > span > button': {
          borderRadius: 0,
          boxShadow: 'none',
          marginLeft: 0,
          marginRight: 0
        },
        '& > button:first-child, & > span:first-child > button': {
          borderTopLeftRadius: button.borderRadius,
          borderBottomLeftRadius: button.borderRadius
        },
        '& > button:last-child, & > span:last-child > button': {
          borderTopRightRadius: button.borderRadius,
          borderBottomRightRadius: button.borderRadius
        },
        '& > button:not(.wrenchButton--ghost):not(:first-child), & > span:not(:first-child) > button:not(.wrenchButton--ghost)': {
          borderLeft: [1, 'solid', palette.background.light],
          borderLeftWidth: radio && '0'
        },
        '& > button.wrenchButton--ghost:not(:first-child), & > span:not(:first-child) > button.wrenchButton--ghost': {
          borderLeft: 'none'
        },
        '& > button.wrenchButton--alt:not(:first-child), & > span:not(:first-child) > button.wrenchButton--alt': {
          borderLeft: 'none'
        }
      };
    }
  };
});
var _excluded = ["radio", "children"];

var ButtonGroup = function ButtonGroup(_ref) {
  var radio = _ref.radio,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var theme = useTheme();

  var _useStyles = useStyles({
    radio: radio,
    theme: theme
  }),
      wrenchButtonGroup = _useStyles.wrenchButtonGroup;

  return /*#__PURE__*/React.createElement("div", Object.assign({
    role: "group",
    className: wrenchButtonGroup
  }, safeRest(props)), children);
};

ButtonGroup.displayName = "ButtonGroup";
ButtonGroup.propTypes = {
  children: PropTypes.node.isRequired,

  /**
   * Set to true if the ButtonGroup will be used similar to a radio or tab component.
   */
  radio: PropTypes.bool
};
ButtonGroup.defaultProps = {
  radio: false
};
export { ButtonGroup };